export default "__VITE_ASSET__BMpH9suM__"